





































import { UserEmail } from '@/models';
import store from '@/store';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    pictureUrl: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: true
    },
    emails: {
      type: Array as PropType<UserEmail[]>,
      required: true
    },
    membershipCount: {
      type: Number,
      required: false
    },
    clickDisabled: {
      type: Boolean,
      default: false
    },
    archived: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // If we have a value for `name`, use it.
    displayName(): string {
      return this.name || this.email;
    },

    // If we have a value for `name`, show the email.  If we don't, then
    // don't show the email since we've already used it in place of the
    // name.
    displayEmail(): string | null {
      return this.name ? this.emails.map(ue => ue.email).join(', ') : null;
    },

    showMembershipCount(): boolean {
      return this.membershipCount === 0 || !!this.membershipCount;
    },

    membershipSuffix(): string {
      return this.membershipCount === 1 ? 'group' : 'groups';
    },

    adminAccess(): boolean {
      return store.state.org.adminAccess;
    }
  }
});
